export default __webpack_public_path__ + "static/media/nordine.ed28fd3d.jpg";